/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Checkemailtitle2Inputs */

const zh_auth_checkemailtitle2 = /** @type {(inputs: Auth_Checkemailtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请查收邮件`)
};

const en_auth_checkemailtitle2 = /** @type {(inputs: Auth_Checkemailtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const es_auth_checkemailtitle2 = /** @type {(inputs: Auth_Checkemailtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Auth_Checkemailtitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_checkemailtitle2 = /** @type {((inputs?: Auth_Checkemailtitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Checkemailtitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_checkemailtitle2(inputs)
	if (locale === "en") return en_auth_checkemailtitle2(inputs)
	return es_auth_checkemailtitle2(inputs)
});
export { auth_checkemailtitle2 as "auth_checkEmailTitle" }